import React, { useState, useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { CheckSquare } from 'lucide-react';
import api from '../utils/api';

export default function Tasks() {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/tasks').then(res => setTasks(res.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center h-96"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-6" data-testid="tasks-page">
      <div><h1 className="text-4xl font-bold text-gray-900">Tasks</h1><p className="text-gray-600">Manage your tasks and activities</p></div>
      <Card><CardContent className="p-6"><div className="space-y-3">{tasks.map(task => (<div key={task.id} className="flex items-center space-x-3 p-3 border rounded-lg" data-testid={`task-${task.id}`}><CheckSquare className="w-5 h-5 text-blue-600" /><div><h3 className="font-semibold">{task.title}</h3><p className="text-sm text-gray-600">{task.status} • {task.priority}</p></div></div>))}{tasks.length === 0 && <p className="text-center py-12 text-gray-500">No tasks found</p>}</div></CardContent></Card>
    </div>
  );
}
